import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ButtonLoader } from '../../../../core';
import { TituloReceberFormComponent } from '../titulo-receber-form.component';
import { TituloReceber } from '../../titulo-receber';
import { TituloReceberAuthGuardService } from '../../services';


interface Config {
    canInsert: boolean;
    canEdit: boolean;
    canVisualizar: boolean;
}

@Component({
    selector: 'sgt-titulo-receber-form-modal',
    templateUrl: './titulo-receber-form-modal.component.html',
    styleUrls: ['./titulo-receber-form-modal.component.less']
})
export class TituloReceberFormModalComponent implements OnInit {
    config: Config;
    title = 'Título a Receber';
    elModal: any;
    isOpen: boolean

    idTituloReceber: number;
    editMode: boolean;
    readonly: boolean;

    @ViewChild('form') form: TituloReceberFormComponent;
    @Output() afterInsert = new EventEmitter<TituloReceber>();
    @Output() afterEdit = new EventEmitter<TituloReceber>();
    @Output() afterCancel = new EventEmitter<any>();

    constructor(private el: ElementRef,
                private tituloReceberAuthGuardService: TituloReceberAuthGuardService) { }

    ngOnInit() {
        this.create();
    }

    private setConfig() {
        this.config = {
            canInsert: this.tituloReceberAuthGuardService.canInsert(),
            canEdit: this.tituloReceberAuthGuardService.canEdit(this.idTituloReceber),
            canVisualizar: this.tituloReceberAuthGuardService.canVisualizar()
        };
    }


    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.isOpen = true;
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                setTimeout(() => {
                    if (this.readonly) {
                        this.form?.visualizar(this.idTituloReceber);
                    } else if (this.editMode) {
                        this.form?.edit(this.idTituloReceber);
                    } else {
                        this.form?.insert();
                    }

                    this.setConfig();
                }, 0)
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.isOpen = false;
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    insert(title = 'Adicionando novo título a receber') {
        this.title = title;
        this.editMode = false;
        this.readonly = false;
        this.idTituloReceber = null;
        this.open();
    }

    edit(idTituloReceber: number, title = 'Editando título a receber') {
        this.title = title;
        this.editMode = true;
        this.readonly = false;
        this.idTituloReceber = idTituloReceber;
        this.open();
    }

    visualizar(idTituloReceber: number, title = 'Visualizando título a receber') {
        this.title = title;
        this.editMode = true;
        this.readonly = true;
        this.idTituloReceber = idTituloReceber;
        this.open();
    }

    /** Abre o modal */
    private open() {
        this.isOpen = true;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Fecha o modal */
    close() {
        this.elModal.modal('hide');
    }

    /** Limpas as variáveis utilizadas no modal */
    private clear() {
        this.idTituloReceber = null;
        this.form?.clear();
    }

    cancel() {
        this.afterCancel.emit();
        this.close();
    }

    save() {
        const btn = new ButtonLoader('#btnSaveTituloReceberFormModal');
        btn.loading('Salvando');

        this.form?.save()
            .then(entity => {
                btn.reset();
                if (this.form?.editMode) {
                    this.afterEdit.emit(entity);
                } else {
                    this.afterInsert.emit(entity);
                }

                this.close();
            })
            .catch(() => {
                btn.reset();
            });
    }
}
